/**
 * RivalryProReset — iter87.78.iso · consume a password-reset token.
 *
 * Route: /rivalry-pro/reset/:token
 */
import { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Star, Loader2, KeyRound } from "lucide-react";
import { proApi } from "./api";

export default function RivalryProReset() {
    const navigate = useNavigate();
    const { token } = useParams();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 8) {
            toast.error("Password must be at least 8 characters");
            return;
        }
        if (password !== confirmPassword) {
            toast.error("Passwords don't match");
            return;
        }
        setBusy(true);
        try {
            await proApi.resetPassword(token, password);
            toast.success("Password set — please sign in");
            navigate("/rivalry-pro/login");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Reset failed");
        }
        setBusy(false);
    };

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-4" data-testid="rivalry-pro-reset-shell">
            <div className="brutal-card max-w-md w-full p-6 space-y-4">
                <div className="flex items-center gap-2">
                    <Star className="w-5 h-5 text-cyber" />
                    <h1 className="font-display font-black text-xl tracking-tight">
                        RIVALRY <span className="text-cyber">PRO+</span>
                    </h1>
                </div>
                <p className="text-xs text-zinc-400">Set your new Rivalry Pro+ password.</p>
                <form onSubmit={submit} className="space-y-3">
                    <label className="block">
                        <span className="text-[10px] uppercase tracking-wider text-zinc-500 font-bold">New password</span>
                        <input
                            data-testid="rivalry-pro-reset-new-password"
                            type="password"
                            autoFocus
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="brutal-input text-sm w-full mt-1"
                            minLength={8}
                        />
                    </label>
                    <label className="block">
                        <span className="text-[10px] uppercase tracking-wider text-zinc-500 font-bold">Confirm password</span>
                        <input
                            data-testid="rivalry-pro-reset-confirm-password"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="brutal-input text-sm w-full mt-1"
                            minLength={8}
                        />
                    </label>
                    <button
                        type="submit"
                        disabled={busy}
                        data-testid="rivalry-pro-reset-submit-btn"
                        className="brutal-btn-primary text-sm py-2 w-full disabled:opacity-40"
                    >
                        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />}
                        Set password
                    </button>
                </form>
                <Link
                    to="/rivalry-pro/login"
                    className="text-[11px] text-cyber hover:underline w-full text-center block"
                    data-testid="rivalry-pro-reset-cancel-link"
                >
                    Back to sign in
                </Link>
            </div>
        </div>
    );
}
